export const TriggerKeys = {
  KEY_RETURN: 13,
  KEY_ENTER: 14,
  KEY_TAB: 9,
  KEY_SPACE: 32,
};
